import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { makeStyles } from '@material-ui/core/styles';
import { getFormatedDate } from '../../../../helper';
import { formatToKOrM } from '../../../../helper';




const useStyles = makeStyles((_theme) => ({
  chartContainer: {
    position: 'relative',
    overflow: 'hidden',
  },
  sliderContainer: {
    margin: '10px 0',
    position: 'relative',
    maxWidth: '300px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  sliderWrapper: {
    position: 'relative',
    height: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  slider: {
    WebkitAppearance: 'none',
    width: '100%',
    height: '4px',
    background: '#e0e0e0',
    borderRadius: '2px',
    outline: 'none',
    '&::-webkit-slider-thumb': {
      WebkitAppearance: 'none',
      width: '20px',
      height: '20px',
      background: '#0067A1',
      borderRadius: '50%',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      '&:hover': {
        transform: 'scale(1.1)',
        background: '#004d80',
      },
      '&:active': {
        transform: 'scale(1)',
      }
    },
  },
  pageIndicator: {
    position: 'absolute',
    right: '0',
    bottom: '-24px',
    color: '#666',
    fontSize: '0.8rem',
    fontWeight: 400,
    fontFamily: 'system-ui, sans-serif',
    '& span': {
      color: '#0067A1',
      fontWeight: 500,
    }
  },
  progressTrack: {
    position: 'absolute',
    height: '4px',
    background: '#0067A1',
    borderRadius: '2px',
    transition: 'width 0.3s ease',
  },
}));

const ChartsForIF = ({ graphData = [], activeTab, _type, showAnnotation = false }) => {
  const classes = useStyles();
  const [borderRadius, setBorderRadius] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  useEffect(() => {
    setCurrentPage(0);
  }, [activeTab]);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 1000) {
        setBorderRadius(2);
      } else if (screenWidth < 1500) {
        setBorderRadius(5);
      } else {
        setBorderRadius(7);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const totalItems = graphData?.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Data mapping based on `activeTab`
  let seriesData = [];
  let yAxisTitle = '';

  let categories = [];


  if (activeTab === 'COF') {
    categories = graphData?.map((item) => item?.Month || 'Unknown Metric');
    seriesData = [
      {
        name: 'Actual COF',
        type: "bar",
        data: graphData?.map((item) => item?.Actual_COF || 0),

      },
      {
        name: 'COF Increase',
        type: "bar",
        data: graphData?.map((item) => item?.COF_Increase || 0),
      },
    ];
    yAxisTitle = 'COF Percentage';

  } else if (activeTab === "Cost Savings") {
    categories = graphData?.map((item) => item?.year_month || 'Unknown Metric');
    seriesData = [
      {
        name: 'Cost Savings',
        type: "area",
        data: graphData?.map((item) => item?.Actual_cost_saving || 0),
      },

    ];
    yAxisTitle = "Cumulative savings ($M) ";

  } else if (activeTab === "Delivery Cost") {
    categories = graphData?.map((item) => item?.YearMonth || 'Unknown Metric');
    seriesData = [
      {
        name: 'Delivery Cost',
        type: "line",
        data: graphData?.map((item) => item?.Delivery_Cost || 0),

      },
    ];
    yAxisTitle = "$ Per Case";

  } else if (activeTab === "alert") {
    seriesData = [
      {
        name: 'N POOS Risk',
        data: graphData?.map((item) => item?.Value || 0),
      },
    ];
    yAxisTitle = "Inventory wastes at risk $M ";
  } else if (activeTab === "COST INCREASE MOM") {
    seriesData = [
      {
        name: 'Spending',
        data: graphData?.map((item) => item?.Spend || 0),
      },
    ];
    yAxisTitle = "Est Spending for awards $";
  }


  // Slice data for current page
  const slicedCategories = categories?.slice(startIndex, endIndex);

  console.log(activeTab, 'activeTab', graphData, slicedCategories);

  const slicedSeries = seriesData?.map(s => ({
    ...s,
    data: s.data?.slice(startIndex, endIndex)
  }));


  // Chart options
  const options = {
    chart: {
      height: 350,
      type: 'bar',
      stacked: true,
      toolbar: { show: false },

      animations: {
        enabled: true,
        easing: 'easeInOutQuad',
        speed: 600,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "20%",
        borderRadius: borderRadius,
        borderRadiusApplication: 'end',
      },

    },
    dataLabels: { enabled: false },
    series: slicedSeries,
    stroke: {
      width: 3,
      curve: 'straight',
    },
    colors: ['#EC6FBD', '#A4D65D', '#01B2AA', "#0067A1"],
    xaxis: {
      categories: slicedCategories,
    },
    yaxis: [
      {
        title: {
          text: yAxisTitle,
          style: {
            fontSize: '12px',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 500,
            color: '#333',
          },
        },
        labels: {
          formatter: (value) =>
            activeTab === "COF"
              ? `${value?.toFixed(2)}%`
              : `$${formatToKOrM(value)}`
        }
      },
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (value) => activeTab === "COF" ? `${value?.toFixed(2)}%` : `$${formatToKOrM(value)}`,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      markers: {
        width: 12,
        height: 12,
        radius: 10,
        shape: "circle",
      },
    },
    annotations: {
      yaxis: showAnnotation
        ? [
          {
            y: activeTab === "COF" ? 98 : 0.38,
            borderColor: '#B0B0B0',
            strokeDashArray: [5, 5],
            label: {
              borderColor: '#B0B0B0',
              style: {
                color: '#B0B0B0',
                padding: '20px',
                fontSize: '10px',
              },
              text: activeTab === "COF" ? "Target = 98%" : "Target = 0.38%",
            },
          },
        ]
        : [],
    },
    grid: { show: false },
  };

  return (
    <div className="grouped-bar-chart">
      <ReactApexChart options={options} series={slicedSeries} type="bar" height={350} />

      {totalPages > 1 && (
        <div className={classes.sliderContainer}>
          <div className={classes.sliderWrapper}>
            <div
              className={classes.progressTrack}
              style={{
                width: `${((currentPage + 1) / totalPages) * 100}%`,
                opacity: 0.3
              }}
            />
            <input
              type="range"
              min="0"
              max={totalPages - 1}
              value={currentPage}
              onChange={(e) => setCurrentPage(parseInt(e.target.value, 10))}
              className={classes.slider}
            />
          </div>
          <div className={classes.pageIndicator}>
            <span>{currentPage + 1}</span> / {totalPages}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChartsForIF;